import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import Contact from '../home/components/Contact';
import WhatsAppDiagnostic from '../home/components/WhatsAppDiagnostic';

export default function ReparationBaieVitreeLyon() {
  const services = [
    {
      icon: 'ri-layout-masonry-line',
      title: 'Grandes Surfaces Vitrées',
      description: 'Remplacement de vitrage sur mesure pour baies vitrées de toutes dimensions.',
      price: 'À partir de 250€'
    },
    {
      icon: 'ri-drag-move-line',
      title: 'Rails Coulissants',
      description: 'Réparation et remplacement de rails, galets et systèmes de roulement.',
      price: 'À partir de 100€'
    },
    {
      icon: 'ri-door-open-line',
      title: 'Portes-Fenêtres',
      description: 'Ajustement, réparation de mécanismes et remplacement de vitrage.',
      price: 'À partir de 180€'
    },
    {
      icon: 'ri-lock-unlock-line',
      title: 'Systèmes de Verrouillage',
      description: 'Installation et réparation de serrures multipoints pour baies vitrées.',
      price: 'À partir de 130€'
    },
    {
      icon: 'ri-temp-cold-line',
      title: 'Isolation Renforcée',
      description: 'Amélioration de l\'isolation thermique et phonique de vos baies vitrées.',
      price: 'À partir de 150€'
    },
    {
      icon: 'ri-shield-keyhole-line',
      title: 'Sécurisation',
      description: 'Vitrage anti-effraction et systèmes de sécurité renforcés.',
      price: 'Sur devis'
    }
  ];

  const bayTypes = [
    {
      title: 'Baie Coulissante',
      description: 'Système à 2, 3 ou 4 vantaux coulissants',
      icon: 'ri-slideshow-3-line'
    },
    {
      title: 'Baie à Galandage',
      description: 'Vantaux s\'escamotant dans le mur',
      icon: 'ri-layout-right-line'
    },
    {
      title: 'Baie Fixe',
      description: 'Grande surface vitrée non ouvrante',
      icon: 'ri-layout-grid-line'
    },
    {
      title: 'Baie Pliante',
      description: 'Système accordéon pour ouverture totale',
      icon: 'ri-layout-column-line'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-cyan-600 via-teal-500 to-cyan-400 pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl">
            <div className="inline-flex items-center space-x-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
              <i className="ri-map-pin-line text-white"></i>
              <span className="text-white text-sm font-medium">Lyon et Métropole - Expert Baies Vitrées</span>
            </div>
            
            <h1 className="text-5xl lg:text-6xl font-extrabold text-white mb-6 leading-tight">
              Réparation Baie Vitrée Lyon
            </h1>
            
            <p className="text-xl text-white/90 mb-8 leading-relaxed">
              Expert en réparation de baies vitrées à Lyon. Intervention rapide sur tous types de baies coulissantes, à galandage, fixes ou pliantes. Remplacement de vitrage, réparation de rails et sécurisation.
            </p>
            
            <div className="flex flex-wrap gap-4">
              <a
                href="#contact"
                className="inline-flex items-center justify-center bg-white text-cyan-600 px-8 py-4 rounded-full font-bold hover:bg-gray-50 transition-all shadow-lg whitespace-nowrap cursor-pointer"
              >
                Devis Gratuit Rapide
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="tel:0478XXXXXX"
                className="inline-flex items-center justify-center bg-white/10 backdrop-blur-sm text-white border-2 border-white px-8 py-4 rounded-full font-bold hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>
                Urgence 24/7
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <span className="text-cyan-600 font-semibold text-xs uppercase tracking-wider">
              NOS INTERVENTIONS
            </span>
            <h2 className="text-4xl lg:text-5xl font-extrabold text-gray-900 mt-3 mb-4">
              Services Réparation Baie Vitrée
            </h2>
            <p className="text-gray-600 text-lg max-w-3xl mx-auto">
              Solutions complètes pour tous vos problèmes de baies vitrées
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 cursor-pointer"
              >
                <div className="w-14 h-14 bg-gradient-to-br from-cyan-500 to-teal-400 rounded-full flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-white text-2xl`}></i>
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {service.title}
                </h3>
                
                <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                  {service.description}
                </p>
                
                <div className="pt-4 border-t border-gray-100">
                  <span className="text-cyan-600 font-bold text-lg">{service.price}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Bay Types */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-extrabold text-gray-900 mb-4">
              Types de Baies Vitrées
            </h2>
            <p className="text-gray-600 text-lg">
              Nous intervenons sur tous les systèmes de baies vitrées
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {bayTypes.map((type, index) => (
              <div key={index} className="text-center bg-cyan-50 rounded-2xl p-8 hover:shadow-lg transition-all">
                <div className="w-16 h-16 bg-cyan-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${type.icon} text-cyan-600 text-3xl`}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  {type.title}
                </h3>
                <p className="text-gray-600 text-sm">
                  {type.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <article className="prose prose-lg max-w-none">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              Expert Réparation Baie Vitrée Lyon
            </h2>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              Spécialiste de la <strong>réparation de baies vitrées à Lyon</strong>, nous intervenons rapidement pour tous vos problèmes : vitrage cassé, rails défaillants, problèmes d'ouverture ou d'étanchéité. Notre expertise couvre tous les types de baies vitrées, du système coulissant classique aux baies à galandage les plus sophistiquées.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Pourquoi Choisir une Baie Vitrée ?
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Les baies vitrées sont devenues incontournables dans l'habitat moderne à Lyon. Elles offrent une luminosité exceptionnelle, une ouverture sur l'extérieur, un gain d'espace visuel, et une valorisation immobilière importante. Que ce soit pour un appartement en centre-ville ou une maison avec jardin, la baie vitrée transforme votre espace de vie.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Problèmes Courants et Solutions
            </h3>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-cyan-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Rails encrassés ou usés :</strong> Nettoyage professionnel et remplacement si nécessaire</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-cyan-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Galets de roulement défaillants :</strong> Remplacement pour une ouverture fluide</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-cyan-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Vitrage cassé ou fissuré :</strong> Remplacement sur mesure avec vitrage haute performance</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-cyan-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Problèmes d'étanchéité :</strong> Remplacement de joints et traitement anti-infiltration</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-cyan-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Sécurité insuffisante :</strong> Installation de vitrage anti-effraction et serrures renforcées</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Amélioration des Performances
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              Au-delà de la simple réparation, nous proposons des solutions pour améliorer les performances de vos baies vitrées : remplacement par du double ou triple vitrage pour une meilleure isolation thermique, installation de systèmes de sécurité anti-effraction, pose de volets roulants intégrés, et traitement anti-UV pour protéger votre intérieur.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Intervention Rapide à Lyon
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              Nous intervenons rapidement dans tout Lyon et sa métropole pour la réparation de vos baies vitrées. Service d'urgence disponible 24/7 en cas de vitrage cassé ou de problème de sécurité. Devis gratuit et conseils personnalisés.
            </p>
          </article>
        </div>
      </section>

      {/* WhatsApp Diagnostic */}
      <WhatsAppDiagnostic />

      {/* Contact */}
      <Contact />
      
      <Footer />
    </div>
  );
}
